import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { Virtual } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ActionStatus, GamePlayerStatus } from '../../../../../Constants';
import { clockOutableStaff, ghostedDocks, playersWithGhostableDocks } from '../../../../Game/GamePlayerInfo';
import blank512 from '../../../Common/blank-512x512.png';
import { getFactionTextureUrl, getTextureUrl } from '../../../Common/TextureTools';
import { FateBringsYou } from '../../../Choices/FateBringsYou';

import '../../../Choices/lodging-action.css';
import { ASSETS_URL } from '../../../../../Settings';

class CurrentFate extends Component {
    render() {

        let fate = Array(this.props.gamePlayerData.current_fate).fill(76);
        return <>
            <div className={''}>
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    modules={[ Virtual ]}
                    // className="action-scroller-swiper"
                >
                    {fate.map((targetTextureId, targetIndex) => {
                        return <SwiperSlide key={`t-${targetIndex}`}
                                            virtualIndex={targetIndex}>
                            <img
                                src={getTextureUrl(targetTextureId)}
                                alt="target"
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>;
                    })}
                </Swiper>
            </div>
        </>;
    }
}



export class GhostActionTarget extends Component {
    // Manual §7.2.6 target picker, rendered at WAIT_FOR_TARGET_ID
    // BEFORE the Fate Die. Verbatim port of the target swiper block
    // that used to live inside GhostActionJuice — same Swiper props,
    // same SwiperSlide shape, same TargetingOverlay. Click routes to
    // ghostCommitTarget (engine persists target then runs the roll
    // inline).
    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
        this.state = {
            targets: [],
        }
    }

    componentDidMount() {
        this.setState({
            targets: this.getTargets(),
        });
        // Additive: also light up the competitor hotels as a second
        // target-pick path. The swiper above keeps working untouched.
        const playerIds = this.getTargets().map((t) => t.id);
        window.dispatchEvent(new CustomEvent(
            'highlight-competitors-event',
            { detail: {
                playerIds: playerIds,
                callback: (playerId) => this.api.ghostCommitTarget(playerId),
            } }));
    }

    componentWillUnmount() {
        window.dispatchEvent(
            new Event('clear-competitors-highlight-event'));
    }

    getTargets = () => {
        const targetGamePlayers = playersWithGhostableDocks(
            this.props.gameData,
            this.props.gamePlayerData,
        );
        return targetGamePlayers.map(
            gamePlayer => {
                return {
                    id: gamePlayer.id,
                    seat: gamePlayer.seat,
                    name: gamePlayer.name,
                    src: getFactionTextureUrl(gamePlayer.faction),
                }
            });
    }

    onTargetClick = (swiper) => {
        let index = swiper.clickedIndex;
        if (index < this.state.targets.length) {
            let playerId = this.state.targets[index].id;
            this.api.ghostCommitTarget(playerId);
        }
    }

    render() {
        if (
            this.props.gamePlayerData.status !== GamePlayerStatus.GHOSTING_ID ||
            this.props.gamePlayerData.action_status !== ActionStatus.WAIT_FOR_TARGET_ID
        ) return <></>

        return (
            <div className={'lodging-action'}>
                <div className={'lodging-action-anchor'}>
                    <img
                        src={`${ASSETS_URL}overlays/TargetingOverlay-1080x210.png`}
                        alt="action"
                        className={'swiper-overlay'}
                        style={{opacity: '50%'}}
                    />
                    <Swiper
                        slidesPerView={6}
                        spaceBetween={0}
                        modules={[Virtual]}
                        onClick={this.onTargetClick}  // this is a Target click
                        // className="action-scroller-swiper"
                    >
                        {this.state.targets.map((target, targetIndex) => {
                            return <SwiperSlide key={`t-${targetIndex}`}
                                                virtualIndex={targetIndex}>
                                <img
                                    src={target.src}
                                    alt="target"
                                    title={`Target ${target.name} in Seat ${target.seat}`}
                                    // className={'draft-card-img'}
                                />
                            </SwiperSlide>
                        })}
                    </Swiper>
                </div>
            </div>
        )
    }
}


export class GhostActionJuice extends Component {
    STAFF_TEXTURE_ID = 157;
    GHOST_TEXTURE_ID = 76;

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
        this.state = {
            sellableRobots: [],
            soldRobots: [],
            startingFate: 0,
            currentFate: 0,
            texture: getTextureUrl(this.GHOST_TEXTURE_ID),
            textureId: this.GHOST_TEXTURE_ID,
            staffTexture: getTextureUrl(this.STAFF_TEXTURE_ID),
            ghostedDocks: [],
        }
    }

    componentDidMount() {
        this.setState({
            sellableRobots: clockOutableStaff(this.props.gamePlayerData),
            startingFate: this.props.gamePlayerData.current_fate,
            currentFate: this.props.gamePlayerData.current_fate,
            ghostedDocks: ghostedDocks(this.props.gamePlayerData),
        }, this.highlightDocks);
    }

    _isSelfTarget = () => {
        // Manual §7.2.6: target was committed BEFORE the roll. Self-
        // target → cleanse own docks; opponent-target → attack (engine
        // queues ghosts on the opp, no per-dock UI here).
        const target = this.props.gamePlayerData.current_action_target;
        return target == null || target === this.props.gamePlayerData.id;
    }

    highlightDocks = () => {
        // Dock-click is the self-cleanse affordance. For opp-target it
        // would mislead (engine ignores the dock and routes to
        // apply_attack); the Confirm button in the juice bar is how the
        // opp-attack commit happens.
        if (!this._isSelfTarget()) return this.clearDocks();
        window.dispatchEvent(
            new CustomEvent('highlight-docks-event',
                {
                    detail: {
                        highlightedDocks: this.state.ghostedDocks,
                        callback: this.dockClick
                    }
                }));
    }

    clearDocks = () => {
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if the board has changed, reset.
        if (clockOutableStaff(this.props.gamePlayerData).length >
            (this.state.sellableRobots.length + this.state.soldRobots.length)) {
            this.resetStaff();
        }
    }

    componentWillUnmount() {
        this.clearDocks();
    }

    dockClick = (dock) => {
        this.api.ghostFullAction(
            this.state.soldRobots,
            this.props.gamePlayerData.id,
            dock
        );
        this.clearDocks();
    }

    actionImage = (props) => {
        if (props.texture === this.STAFF_TEXTURE_ID) {
            return this.staffImage(props);
        }

        let isPurchased = (props.index + 1 > this.state.startingFate);

        return <div>
            <img
                src={this.state.texture}
                alt="action"
                // className={'inventory-selector-image'}
            />

            {isPurchased &&
                <div className={'purchased-action-container'}>
                    <div className={'purchased-action-parent'}>
                        <div className={'purchased-action-robot-container'}>
                            <img
                                src={this.state.staffTexture}
                                alt="robot"
                                className={'purchased-action-robot'}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    };

    staffImage = (props) => {
        return <div>
            <img
                src={this.state.staffTexture}
                alt="action"
                // className={'inventory-selector-image'}
            />
        </div>
    };

    onStaffClick = () => {
        let sellableRobots = this.state.sellableRobots;
        let soldRobot = sellableRobots.pop()
        this.setState({
                sellableRobots: sellableRobots,
                soldRobots: [...this.state.soldRobots, soldRobot],
                currentFate: this.state.currentFate + 2,
            },
            this.showLodgingUpgrades);
    }

    resetStaff = () => {
        this.setState({
            sellableRobots: [...this.props.receivedMessage.package.data.sellable_robots],
            soldRobots: [],
            currentFate: this.state.startingFate,
        }, this.showLodgingUpgrades);
    }

    onJuiceBarClick = (swiper) => {
        let index = swiper.clickedIndex;
        const isSelfTarget = this._isSelfTarget();
        const hasReset = this.state.soldRobots.length > 0;
        const hasSkip = this.state.currentFate === 0;
        // Opp-target needs an explicit Commit since the dock-click
        // self-cleanse affordance is gated off.
        const hasConfirm = !isSelfTarget && this.state.currentFate > 0;

        let prefixIndex = 0;
        if (hasReset) {
            if (index === prefixIndex) return this.resetStaff();
            prefixIndex++;
        }
        if (hasSkip) {
            if (index === prefixIndex) {
                this.api.ghostJuice(this.state.soldRobots);
                return;
            }
            prefixIndex++;
        }
        if (hasConfirm) {
            if (index === prefixIndex) {
                this.clearDocks();
                this.api.ghostJuice(this.state.soldRobots);
                return;
            }
            prefixIndex++;
        }

        const dataIndex = index - prefixIndex;
        if (dataIndex < 0) return;
        const item = this.getJuiceBarData()[dataIndex];
        if (item === 157) {  // click robot
            this.onStaffClick();
        }
        // item === 72 (ghost action icon) — no-op, dead historical branch.
    }

    getJuiceBarData = () => {
        let selectors = Array(this.state.currentFate).fill(this.state.textureId);
        let robots = Array(this.state.sellableRobots.length).fill(157);
        return [...selectors, ...robots];
    }

    render() {
        if (
            this.props.gamePlayerData.status !== GamePlayerStatus.GHOSTING_ID ||
            this.props.gamePlayerData.action_status !== ActionStatus.WAIT_FOR_JUICE
        ) return <></>


        return (
            <div className={'lodging-action'}>
                <FateBringsYou
                    currentFate={this.state.currentFate}
                    factionId={6}
                    type={'Ghosts'} />
                <div className={'lodging-action-anchor'} id={'juicer'}>
                    <img
                        src={`${ASSETS_URL}overlays/GhostJuiceOverlay-1080x210.png`}
                        alt="action"
                        className={'lodging-action-background'}
                    />
                    <div className={'lodging-action-flex'}>
                        <div className={'lodging-action-flex-item'}>
                            <Swiper
                                slidesPerView={6}
                                spaceBetween={0}
                                freeMode={true}
                                grabCursor={true}

                                modules={[Virtual]}

                                onSwiper={(swiper) => {
                                    this.swiper = swiper;
                                }}
                                onClick={this.onJuiceBarClick}
                                // className="action-scroller-swiper"
                            >
                                {this.state.soldRobots.length > 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-reset`}
                                                     virtualIndex={-2}>
                                            <Button variant={'seed'}>Reset</Button>
                                        </SwiperSlide>
                                    </div>
                                }
                                {this.state.currentFate === 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-skip`}
                                                     virtualIndex={-1}>
                                            <Button variant={'seed'}>Skip</Button>
                                        </SwiperSlide>
                                    </div>
                                }
                                {!this._isSelfTarget() && this.state.currentFate > 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-confirm`}
                                                     virtualIndex={-3}>
                                            <Button variant={'seed'}>Confirm</Button>
                                        </SwiperSlide>
                                    </div>
                                }
                                {this.getJuiceBarData().map((selector, index) => {
                                    return <SwiperSlide key={`gi-${index}`}
                                                        virtualIndex={index}>
                                        <this.actionImage
                                            texture={selector}
                                            index={index}
                                        />
                                    </SwiperSlide>
                                })}
                                {this.state.currentFate === 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-999`}
                                                     virtualIndex={999}>
                                            <img src={blank512} alt={'blank'}
                                                 className={'blank-image'}
                                            />
                                        </SwiperSlide>
                                    </div>
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export class RemoveGhosts2d extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }
    componentDidMount() {
        this.highlightDockChoices();
        window.addEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }

    componentDidUpdate(prevProps) {
        // The engine's deghost loop re-prompts REMOVE_ID once per owed
        // execution: ghost_action.deghost_docks decrements current_fate
        // and, while it is still > 0, calls prompt_to_remove_ghosts
        // (recursive) which re-stamps REMOVE_ID and re-sends the seat.
        // Status/action_status are unchanged (GHOSTING/REMOVE), so React
        // RE-RENDERS this component without remounting it — componentDidMount
        // fires only for the first execution, and onClick's clearDocks()
        // already wiped that highlight. Without re-dispatching here, every
        // execution after the first had no clickable dock (the count still
        // shows the remaining fate, but the docks are dark — "my AI says I
        // have another ghost action but I don't see it"). Re-light the docks
        // whenever a fresh REMOVE prompt lands (current_fate changed while
        // still owing). highlightDockChoices only dispatches a window event
        // — no state/prop change — so it cannot loop.
        const prev = prevProps.gamePlayerData;
        const curr = this.props.gamePlayerData;
        if (!curr) return;
        const stillRemoving = (
            curr.status === GamePlayerStatus.GHOSTING_ID
            && curr.action_status === ActionStatus.REMOVE_ID);
        const fateChanged = !prev
            || prev.current_fate !== curr.current_fate;
        if (stillRemoving && curr.current_fate > 0 && fateChanged) {
            this.highlightDockChoices();
        }
    }

    mountedEvent = () => {
        this.highlightDockChoices();
    }

    highlightDockChoices = () => {
        window.dispatchEvent(
            new CustomEvent('highlight-docks-event',
                {
                    detail: {
                        highlightedDocks: ghostedDocks(this.props.gamePlayerData),
                        callback: this.onClick
                    }
                }));

    }

    componentWillUnmount() {
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
        window.removeEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }

    clearDocks = () => {
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
    }

    onClick = (dockIndex) => {
        this.api.clickDeGhost(dockIndex);
        this.clearDocks();
    }

    render() {
        return <CurrentFate {...this.props} />
        // return <div className="justify-content-center d-flex align-items-center">
        //     <DeGhostImage />
        // </div>
    }

}
